/* eslint-disable camelcase */

import { v4 as uuid } from "uuid";
import { shopifyApi } from "@/services/api/shopifyApi";
import { mapGetters } from "vuex";
import * as localForage from "localforage";

export default {
  data() {
    return {
      clientId: null,
      scope: null,
      storeName: "",
      loading: true,
    };
  },
  async beforeMount() {
    await this.initConnection();
  },
  computed: {
    ...mapGetters({
      user: "userState",
    }),
  },
  methods: {
    initConnection,
    getShopifyAppData,
    redirectToShopify,
    backToProducts,
    showShopifyError,
  },
};

// eslint-disable-next-line complexity
async function initConnection() {
  // TODO: Split this up to be less complex.

  const shopifyParams = await localForage.getItem("shopify-params");
  let code, hmac, host, shop, state, timestamp, nonce;
  if (shopifyParams && shopifyParams.state) {
    ({ code, hmac, host, shop, state, timestamp } = shopifyParams);
    nonce = state;
  } else if (this.$route.query.code) {
    ({ code, hmac, host, shop, state, timestamp } = this.$route.query);
    nonce = await localForage.getItem("nonce");
  }

  if (code && hmac && host && shop && state && timestamp && nonce) {
    try {
      await shopifyApi.getToken({
        code,
        hmac,
        host,
        shop,
        state,
        nonce,
        timestamp,
      });

      await shopifyApi.startImport(shop);
      await localForage.removeItem("nonce");
      this.$router.push("for-review?shopifyConnected=true");
    } catch (error) {
      await localForage.removeItem("nonce");
      await localForage.removeItem("shopify-params");
      this.showShopifyError();
    } finally {
      this.loading = false;
    }
  } else {
    await localForage.removeItem("nonce");
    await localForage.removeItem("shopify-params");
    await this.getShopifyAppData();
  }
}

async function getShopifyAppData() {
  try {
    const { data } = await shopifyApi.installApp();
    const { client_id, scope } = data;

    this.clientId = client_id;
    this.scope = scope;
  } catch (error) {
    this.showShopifyError();
    this.loading = false;
    this.$bugsnagClient.notify(error);

  } finally {
    const { shop } = this.$route.query;

    if (shop) {
      const { connected } = await shopifyApi.getState();
      const splitShop = shop.split(".myshopify.com");
      // eslint-disable-next-line no-console
      console.log("splitshop: ", splitShop, " , connected: ", connected);
      if (splitShop && !connected) {
        this.storeName = splitShop[0];
        this.loading = false;
        this.redirectToShopify();
      }

      if (connected) {
        await this.$swal("Attention", "Shopify already connected!");
        this.backToProducts();
      }
    }

    this.loading = false;
  }
}

async function redirectToShopify() {
  if (!this.storeName || this.storeName === "" || this.loading) {
    this.$swal("Attention", "Please provide store name.");
    return;
  }

  if (this.storeName.includes(" ") || this.storeName.includes("myshopify.com")) {
    this.$swal("Attention", "Invalid store name.");
    return;
  }

  const redirectUri = `${window.location.origin}/dashboard/connect-shopify`;

  let nonce = undefined;
  if (this.user && this.user.id) {
    nonce = `${this.user.id}-${uuid()}`;
  } else {
    nonce = uuid();
  }

  await localForage.setItem("nonce", nonce);
  window.location.href = `https://${this.storeName}.myshopify.com/admin/oauth/authorize?client_id=${this.clientId}&scope=${this.scope}&redirect_uri=${redirectUri}&state=${nonce}`;
}

function backToProducts() {
  this.$router.push("products");
}

function showShopifyError() {
  this.$swal("Connect Shopify", "Something went wrong. Please try again later");
}
